const redirect = (props, str_url) => {
    props.history.push(str_url)
}

export default redirect